/*
  Одно действие за раз (аудит 26.10.2026, причина 4: нет защиты от двойного нажатия).

  Два быстрых нажатия на «Сохранить» или «Завести» давали два запроса, две записи в
  журнале изменений и - у загрузки - повторную запись того же файла. Защита одним
  `disabled={busy}` не держит: состояние обновляется после отрисовки, а второе нажатие
  успевает раньше. Поэтому первой защитой служит ссылка, которая меняется сразу, а
  `busy` нужен экрану, чтобы показать кнопку серой.

  `run(действие)` возвращает результат действия или `undefined`, если оно пропущено
  как повторное. Исключение действия пролетает наружу: ошибку показывает вызывающий.
*/

import { useCallback, useRef, useState } from 'react'

export default function useSingleFlight() {
  const flying = useRef(false)
  const [busy, setBusy] = useState(false)

  const run = useCallback(async (action) => {
    if (flying.current) return undefined
    flying.current = true
    setBusy(true)
    try {
      return await action()
    } finally {
      flying.current = false
      setBusy(false)
    }
  }, [])

  return { run, busy }
}
